/*Edit thong tin ve nguon tin va tai nan, phuong tien bi nan */
import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import SelectFilter from "react-select";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DropzoneArea } from "material-ui-dropzone";
import MyLatLonEditor from "./LatLonEditor";
import FileAttachControl from './FileAttachControl';
import ConfirmDialog from '../ConfirmDialog';

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "../MyButton";

const myLib = require("../../lib/MyLib");
const server = require("../../lib/server");
const sukienLayer = require("../../lib/SuKienDataLayer");
///////////////////////////////////////////////////////////////////
const defaultRecord = {
  files: [], //danh sach file
};

class SuKienDinhKemControl extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      showConfirmXoa: false, //hien thi dialog confirm xoa file
      requestXoaFileID: undefined,
      //danh muc quoc gia
      loading_quoctich: true, // co dang loading danh muc quoc gia khong
      source_quoctich: [], //danh muc options cho quoc tich
      //danh sach file da upload
      fileDinhKem: props.savedFiles === undefined ? [] : (props.savedFiles ?? []),
      showConfirmXoa: false,
      requestXoaFileID: 0,
      before:
        props.value === undefined
          ? {
            ThoiGian: new Date(),
          }
          : props.value, //thong tin truoc khi edit
      after:
        props.value === undefined
          ? defaultRecord
          : { ...defaultRecord, ...props.value }, //thong tin dang edit
      validateStatus: {},
      mountUploader: true,
    };
    console.log(props.savedFiles, 'file dinh kem');
  }
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = true;
    s.canSaved = true;
    console.log(s);
    this.setState(s);
  };
  //submit thong tin ve DB
  handleSave = () => {
    console.log(JSON.stringify('after file ', this.state.after.files));
    if (!(this.state.after.files && this.state.after.files.length && this.state.after.files[0].name)) {
      if (this.props.onSaved) {
        this.props.onSaved(this.state.after);
      }
      return;
    }
    var check = sukienLayer.validate("dinhkem", this.state.after);
    if (!check.error) {
      this.setState({ validateStatus: check, saving: true, errorLog: "" });
      const formData = new FormData();
      this.state.after.files.map((item, index) => {
        if (item.name !== undefined) {
          formData.append('file' + index, item, item.name);
        }
      });
      formData.append('MaSK', this.state.after.MaSK);
      server
        .upload(
          "sukien/SaveDinhKem",
          formData
        )
        .then((response) => {
          console.log('save dinh kem response:', response);
          var before = {};
          var after = this.state.after;
          Object.assign(before, after);
          this.setState({
            before: before,
            after: after,
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
            mountUploader: false,
            fileDinhKem: response,
          });
          //thong bao cho parent biet co data duoc saved
          if (this.props.onSaved) {
            this.props.onSaved(after);
          }
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    } else {
      this.setState({ validateStatus: check });
    }
  };
  loadDanhMuc() {
  }
  //khi load component: load cac danh muc can thiet
  componentDidMount() {
    this.loadDanhMuc();
  }
  static getDerivedStateFromProps(props, state) {
    var newState = { ...state };
    //console.log("TaiNanControl props:", props.value);
    if (props.value !== undefined && props.value.MaSK !== state.after.MaSK) {
      //console.log("co su thay doi");
      //co su thay doi
      newState = {
        ...newState,
        after: { ...state.after, ...props.value },
      }; //lay thong tin tu parent form truyen vao thong qua props
    }
    //console.log("TaiNanControl new state:", newState);
    return newState;
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <Accordion disabled={this.props.disabled}
        defaultExpanded={this.props.value !== undefined}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{
            root: classes.normalPanel,
            expanded: classes.expandedPanel,
          }}
        >
          <Typography className={classes.heading}>Tài liệu đính kèm</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {this.state.fileDinhKem && this.state.fileDinhKem.map && this.state.fileDinhKem.map((item, index) =>
                <FileAttachControl file={item} requestDelete={(fileID) => {
                  //yeu cau xoa
                  this.setState({ showConfirmXoa: true, requestXoaFileID: fileID });
                }} />
              )
              }
              {this.state.showConfirmXoa ? <ConfirmDialog message="Xóa file?" callback={(ok) => {
                //thuc hien xoa file
                if (ok) {
                  this.setState({
                    showConfirmXoa: false,
                    validateStatus: {},
                    saving: true,
                    errorLog: "",
                  });
                  //call api to clear
                  server
                    .post("sukien/removeDinhkem", { FileID: this.state.requestXoaFileID })
                    .then((response) => {
                      var before = {};
                      var after = { ...this.state.after };
                      Object.assign(before, after);
                      this.setState({
                        before: before,
                        after: after,
                        dataChanged: false,
                        canSaved: false,
                        saving: false,
                        errorLog: "",
                        dataSaved: true,
                        fileDinhKem: response,
                      });
                    })
                    .catch((error) =>
                      this.setState({ saving: false, errorLog: error + "" })
                    );
                }
                else {
                  this.setState({
                    showConfirmXoa: false,
                  });
                }
              }} /> : null}
            </Grid>
            <Grid item xs={12}>
              {this.state.mountUploader ?
                <DropzoneArea
                  filesLimit={100}
                  maxFileSize={32 * 1024 * 1024}
                  showFileNames={true}
                  dropzoneText="Kéo và thả file hoặc bấm vào đây"
                  showAlerts={false}
                  clearOnUnmount={true}
                  onChange={(files) => {
                    console.log("Files:", files);
                    this.saveField('files', files);
                  }
                  }
                /> : <MyButton color="primary" text="Thêm file" onClick={() => this.setState({ mountUploader: true })} />}
            </Grid>
            <Grid item xs={4}>
              {this.state.canSaved ? (
                <MyButton
                  onClick={this.handleSave}
                  color="primary"
                  text="Lưu"
                />
              ) : null}
            </Grid>
            <Grid item xs={10}>
              {this.state.saving ? (
                <CircularProgress />
              ) : this.state.errorLog === "" ? null : (
                this.state.errorLog
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },

  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
});
export default withStyles(styles, { withTheme: true })(SuKienDinhKemControl);
